import React from "react";

const Square = (props) => {
  return (
    <button className="square" onClick={props.onClick}>
      {props.value}
    </button>
  );
};

export default Square;



// WEBPACK FOOTER //
// ./src/components/square.js